// External dependencies.
import domReady from "@wordpress/dom-ready";

( function () {
    const main = document.querySelector( 'main' );
    const footer = document.querySelector( '#ts-footer' );
    const footerTitleContainer = document.querySelector( '#ts-footer-title-container' );
    const footerContent = document.querySelector( '#ts-footer-content' );
    events();

    domReady( function () {
        // setFooter();
    } );

    function events() {
        window.addEventListener( 'resize', setFooter );
        footerTitleContainer && footerTitleContainer.addEventListener( 'click', toogleFooterContent );
    }

    function setFooter() {
        /*
        if ( !footer ) {
            return;
        }

        const height = parseInt( footer.clientHeight );
        footer.style.marginTop = `-${height}px`;
        main.style.paddingBottom = `${height}px`;
        */
    }

    function toogleFooterContent() {
        if ( window.matchMedia( "(min-width: 992px)" ).matches || !footerContent ) {
            return;
        }

        footerContent.classList.toggle( 'ts-footer-content--open' );
    }
} )();
